import { Locale } from "../schema/Locale.js";

const timeFormat: Record<Locale, Intl.DateTimeFormat> = {
	[Locale.cs]: new Intl.DateTimeFormat("cs-CZ", { hour: "numeric", minute: "numeric", timeZone: "Europe/Prague" }),
};

export function toTimeFormat(date: number | Date | string, locale: Locale): string {
	return timeFormat[locale].format(new Date(date));
}
